import ky from "ky";
import { z } from "zod";

const ErrorSchema = z.object({ error: z.object({ message: z.string() }) });

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function request<T>(
  path: string,
  schema: z.ZodType<T>,
  init?: RequestInit,
): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await ky(path, {
    ...init,
    headers,
    credentials: "same-origin",
    timeout: 30_000,
    retry: 0,
    throwHttpErrors: false,
  });
  const body: unknown = await response.json();
  if (!response.ok) {
    const error = ErrorSchema.safeParse(body);
    throw new ApiError(
      response.status,
      error.success ? error.data.error.message : "The request could not be completed.",
    );
  }
  return schema.parse(body);
}
